module.exports = __webpack_public_path__ + "img/4.f0721cf4.jpg";